import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        fontSize: '26px',
        color: theme.palette.black,
        fontWeight: 'bold',
        marginTop: '170px',
    },
    dashboardTitle: {
        fontSize: '24px',
        color: theme.palette.black,
        fontWeight: 'bold',
    },
    actionsContainer: {
        display: 'flex',
        flexDirection: 'row',
        columnGap: '10px',
        rowGap: '5px',
        alignItems: 'flex-end',
    },
    exportButton: {
        backgroundColor: '#EBA900',
        font: 'white',
        textTransform: 'capitalize',
    },
    navigateNewButton: {
        marginTop: '20px',
        width: '140px',
        height: '35px',
        textTransform: 'capitalize',
    },
}));
